import * as React from 'react';
import { EStarSize, EStarTheme, MobileRating, Star } from '@cian/frontend-reviews-components';
import { useSelector } from 'react-redux';
import { getReviewsStat } from '../../selectors/newbuilding';

export const HeaderReviewStat: React.FC = () => {
  const reviewStat = useSelector(getReviewsStat);

  if (!reviewStat?.reviewsCount) {
    return <Star size={EStarSize.M} theme={EStarTheme.NotFilled} />;
  }

  return <MobileRating value={reviewStat.rating} short />;
};
